import { combineReducers } from 'redux';

import langReducer from '../configuration/lang/langSlice';
import loginReducer from '../configuration/login/loginSlice';
import configReducer from '../configuration/setup/configSlice';
import tokenReducer from '../configuration/tokenHandling/tokenSlice';
import { appReducer } from '../features/app/appReducers/appReducer';
import { contactFormApi } from './contactFormApi';
import { poiApi } from './poiApi';
import { trafficApi } from './trafficApi';

export const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenReducer,
    [contactFormApi.reducerPath]: contactFormApi.reducer,
    [poiApi.reducerPath]: poiApi.reducer,
    [trafficApi.reducerPath]: trafficApi.reducer,
});
